// @flow

import {
  USER_UPDATE, USER_FETCH_BETS_LOADING, USER_FETCH_BETS_SUCCESS, USER_UPDATE_BALANCES, USER_AUTH_REGISTER_FAIL, USER_SET_USERNAME_FAIL, USER_SET_USERNAME_SUCCESS, USER_SET_REFERRAL_SUCCESS, USER_SET_REFERRAL_FAIL, USER_UPDATE_SUCCESS, USER_FETCH_BETS, USER_UPDATE_BALANCES_ERROR, USER_POST_BET_SUCCESS, USER_FETCH_STATS, USER_FETCH_STATS_SUCCESS
} from '../constants/action-types';
import firebase from 'firebase';

window.firebase = firebase

const initialState = {
  user: null,
  balances: {

  },
  userStats: {},
  userStatsLoading: false,
  balancesError: null,
  bets: [],
  betsLoading: false,
  betsError: null
};

const userReducer = (state: Object = initialState, action) => {

  switch (action.type) {
    case USER_UPDATE: {
      return Object.assign({},
        state,
        {
          user: action.payload
        })
    }
    case USER_UPDATE_BALANCES: {
      return Object.assign({},
        state,
        {
          balances: action.payload,
          balancesError: null
        })
    }
    case USER_FETCH_BETS_LOADING: {
      return Object.assign({}, 
        state,
        {
          betsLoading: true
        })

    }
    case USER_FETCH_BETS_SUCCESS: {
      return Object.assign({}, 
        state,
        {
          betsLoading: false,
          bets: action.payload || []
        })
    }
    case USER_FETCH_STATS_SUCCESS: {
      return Object.assign({}, 
        state,
        {
          userStats: action.payload,
          userStatsLoading: false
        })
    }
    case USER_POST_BET_SUCCESS: {
      return Object.assign({}, 
        state)
    }
    case USER_UPDATE_BALANCES_ERROR: {
      console.log(action.payload)
      return Object.assign({},
        state,
        {
          balancesError: action.payload
        })
    }
    default: {
      return state;
    }
  }

};

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js